import React, { useState, useRef, useEffect, useCallback } from 'react';
import Classes from './BrandPage.module.css'
import ProductItem from './ProductItem'
import { NikeProducts, JordansProducts, AdidasProducts, NewBalanceProducts, LVProducts } from '../../data/products'
import BrandSlider from '../Home/FeaturedSection/BrandSlider/BrandSlider'
import SectionCards from '../Home/SectionCards/SectionCards';
import Faq from '../Home/Faq/Faq';
import { Helmet } from 'react-helmet-async';

const BATCH_SIZE = 5;
const MAX_AUTO_BATCHES = 5; // 5 batches of 5 = 25 products

export default function BrandPage({ Products, Recommended, page, title }) {
    const [currentBatch, setCurrentBatch] = useState(1);
    const loaderRef = useRef(null);

    const visibleProducts = Products.slice(0, currentBatch * BATCH_SIZE);

    const handleLoadMore = useCallback(() => {
        setCurrentBatch((prev) => prev + 1);
    }, []);

    // Auto load more on scroll
    useEffect(() => {
        if (currentBatch >= MAX_AUTO_BATCHES) return;

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                handleLoadMore();
            }
        }, { threshold: 1 });

        if (loaderRef.current) {
            observer.observe(loaderRef.current);
        }

        return () => {
            if (loaderRef.current) observer.unobserve(loaderRef.current);
        };
    }, [handleLoadMore, currentBatch]);


    return (
        <>
            <Helmet>
                <title>{title} | Luxaywear</title>
                <meta
                    name="description"
                    content={`Shop the best replica ${title} at LuxayWear Dubai. High-quality look, unbeatable prices.`}
                />
                <meta
                    name="keywords"
                    content={`replica ${title}, ${title} Dubai, buy replica shoes online, cheap branded shoes Dubai, LuxayWear, ${title} dupes UAE`}
                />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href={`https://luxaywear.com/${page}`} />
            </Helmet>

            <div className={Classes.hero} >
                <h1 className={Classes.subheading}> Explore from our stock </h1>
                <p className={Classes.text}>
                    We partner with verified factories across the UAE to bring you premium, stylish footwear <br /> made with expert craftsmanship and the finest materials.
                </p>

                <div className={Classes.header} >
                    <h3>{title}</h3>
                </div>

                <div className={Classes.body}>
                    {visibleProducts.map((product, index) => (
                        <ProductItem
                            key={`${product.id}-${index}`}
                            product={product}
                            index={index}
                        />
                    ))}
                </div>

                {/* 👇 Invisible trigger for auto batch loading */}
                {currentBatch < MAX_AUTO_BATCHES && (
                    <div ref={loaderRef} style={{ height: 1 }} />
                )}

                {/* 👇 Button after 100 products */}
                {visibleProducts.length < Products.length && currentBatch >= MAX_AUTO_BATCHES && (
                    <div style={{ textAlign: 'center' }}>
                        <button className={`${Classes.primaryBtn} ${Classes.showMoreBtn}`} onClick={handleLoadMore}>
                            <h5>Load More Products</h5>
                        </button>
                    </div>
                )}

                <SectionCards />

                <div className={Classes.recommendHero} >
                    <div className={Classes.miniText} > Recommended for you </div>
                    <h1 className={Classes.subheading}> Explore the Best in Footwear </h1>
                    <p className={Classes.text}>
                        Our curated selection of the most renowned brands in the world.
                    </p>

                    {Recommended && Recommended.length > 0 &&
                        Recommended.map((brand, index) => {
                            return (
                                <div key={index} >
                                    {brand === 'Jordans' &&
                                        <>
                                            <BrandSlider title={'Jordans'} Products={JordansProducts} page={'/jordans'} />
                                        </>
                                    }
                                    {brand === 'Adidas' &&
                                        <>
                                            <BrandSlider title={'Adidas'} Products={AdidasProducts} page={'/adidas'} />
                                        </>
                                    }
                                    {brand === 'Nike' &&
                                        <>
                                            <BrandSlider title={'Nike'} Products={NikeProducts} page={'/nike'} />
                                        </>
                                    }
                                    {brand === 'New Balance' &&
                                        <>
                                            <BrandSlider title={'New balance'} Products={NewBalanceProducts} page={'/new-balance'} />
                                        </>
                                    }
                                    {brand === 'LV' &&
                                        <>
                                            <BrandSlider title={'LV'} Products={LVProducts} page={'/lv'} />
                                        </>
                                    }
                                </div>
                            )
                        })
                    }
                </div>

            </div>
            <Faq />
        </>
    )
}
